module.exports = __webpack_public_path__ + "static/media/58.df235715.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/58.png
// module id = 631
// module chunks = 0